export default __webpack_public_path__ + "static/media/lenze_918_3.945b253d.jpg";